import * as React from 'react';

const TopBurgerIcon = (props) => (
    <svg width={40} height={40} fill="none" {...props}>
        <circle cx={20} cy={20} r={20} fill={props.fill || '#181818'} />
        <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11 14h18M11 20h18M11 26h18" />
    </svg>
);
export default TopBurgerIcon;
